import React, { FC, useEffect, useState } from "react";
import { Button, InputField, SelectField } from "../../forms";
 import { useStateGetter } from "../../../hooks/statehooks/UseStateGettersHook";
import { useForm } from "react-hook-form";
import { emailReg, numReg, textReg } from "../../../utils/regex";
import { toast } from "react-toastify";
import { useStateSetter } from "../../../hooks/statehooks/UseStateSettersHook";
import useAppraisalTempHook from "../../../hooks/useAppraisalTempHook";
import { MdCancel } from "react-icons/md";
import RatingBar from "../../forms/RatingBar";
import { onAddAppraisalResponse } from "../../../services/appraisal";
import useAppraisalHook from "../../../hooks/useAppraisalHook";
export default ({ item, show, appraisal }: any) => {
  var { control, handleSubmit, watch } = useForm();
  const { setLoading } = useStateSetter();
  const [questions, setquestions] = useState([]);
  const { SelectedOrg, config, selectedEmployee } = useStateGetter();
  const { getTempQuestions } = useAppraisalTempHook();

const {UpdateAppraisal}=useAppraisalHook()

  const SubmitAppraisal = async (data: any) => {
    console.log(data);
    setLoading(true);
    try {
      await Promise.all(
        questions.map(async (quest: any) => {
          var responsedata = {
            response: data[`question${quest.id}`].toString(),
            questionID: quest.id,
            tempID: quest.tempID,
            organizationID: SelectedOrg.id,
            employeeID: selectedEmployee.id,
          };
          await onAddAppraisalResponse(responsedata, config);
        })
      );
//update appraisal to completed
var res = await UpdateAppraisal(item.id, {
  status: "Completed"
});
 } catch (e) {
      toast.error(e);
    } finally {



      setLoading(false);
      show(false);
    }
  };

  const getquest = async () => {
    setLoading(true);
    try {
      var quest = await getTempQuestions(item.id);
      setquestions(quest);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getquest();
  }, []);

  return (
    <>
      <div className="ModalContainer shadow ">
        <div className=" flex flex-col    rounded-[8px] bg-white min-w-[40vw] p-4  max-h-[90vh] overflow-y-scroll ">
          <div className="flex justify-between items-center my-2 ">
            <p className="font-semibold self-start   "> Appraissal</p>
            <MdCancel
              onClick={() => {
                show(false);
              }}
              size={20}
              className="text-gray-400 "
            />
          </div>
          <p className="text-md font-semibold my-2  text-gray-600">
            {item.name}
          </p>
          <div>
            {questions.map((it: any, key: number) => (
              <div className="my-2">
                <span className="px-1 bg-textbg rounded text-xs  text-white ">
                  {key + 1}
                </span>
                <span className=" text-gray-700 text-xs">{it.question}</span>
                <div className="mx-4">
                  {it.responseType == "ratings" && (
                    <RatingBar
                      name={`question${it.id}`}
                      title="Response"
                      placeholder={"Enter response"}
                      isDisabled={false}
                      control={control}
                      rules={{
                        required: " required",
                        pattern: {
                          value: textReg,
                          message: "Invalid",
                        },
                      }}
                    />
                  )}
                  {it.responseType == "text" && (
                    <InputField
                      name={`question${it.id}`}
                      title="Response"
                      placeholder={"Enter response"}
                      isDisabled={false}
                      control={control}
                      rules={{
                        required: " required",
                        pattern: {
                          value: textReg,
                          message: "Invalid",
                        },
                      }}
                    />
                  )}
                  {it.responseType == "options" && (
                    <SelectField
                      control={control}
                      name={`question${it.id}`}
                      rules={{ required: "required" }}
                      placeholder="Select"
                      title="Response"
                      options={it.options}
                    />
                  )}
                </div>
              </div>
            ))}
          </div>

          <div className="gap-6 w-full flex">
            <Button
              text="Submit Feedback"
              onBtnClick={handleSubmit(SubmitAppraisal)}
            />
          </div>
        </div>
      </div>
    </>
  );
};
